module.exports = "/images/ytSocial.png?ced84b6637176ae3930c93d79f1cfcf9";